
import AddressName from "../address/components/address/AddressDetail/AddressName";
import UserAddressName from "../address/components/userAddress/UserAddressDetail/UserAddressName";

import MembersGroupName from "../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import UserName from "../auth/components/user/UserDetail/UserName";
import UserSessionName from "../auth/components/userSession/UserSessionDetail/UserSessionName";
import RoleName from "../auth/components/role/RoleDetail/RoleName";
import RolePermissionName from "../auth/components/rolePermission/RolePermissionDetail/RolePermissionName";
import MembersGroupUserName from "../auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserName";
import ScopeGroupName from "../auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupName";
import RoleAssignmentName from "../auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentName";

import LocationName from "../location/components/location/LocationDetail/LocationName";

import TimberClassName from "../timber/components/timberClass/TimberClassDetail/TimberClassName";
import ThicknessClassName from "../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassName";
import TimberTypeName from "../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import PricingProfileName from "../timber/components/pricingProfile/PricingProfileDetail/PricingProfileName";
import PriceName from "../timber/components/price/PriceDetail/PriceName";
import BuyerName from "../timber/components/buyer/BuyerDetail/BuyerName";
import BuyerUserName from "../timber/components/buyerUser/BuyerUserDetail/BuyerUserName";
import RoadCarrierName from "../timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierName";
import ContractorName from "../timber/components/contractor/ContractorDetail/ContractorName";
import ContractorUserName from "../timber/components/contractorUser/ContractorUserDetail/ContractorUserName";
import ForestOwnerName from "../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerName";
import ProviderName from "../timber/components/provider/ProviderDetail/ProviderName";
import ProviderUserName from "../timber/components/providerUser/ProviderUserDetail/ProviderUserName";
import AccountingUserName from "../timber/components/accountingUser/AccountingUserDetail/AccountingUserName";
import CuttingName from "../timber/components/cutting/CuttingDetail/CuttingName";
import TimberStorageName from "../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import ShipmentName from "../timber/components/shipment/ShipmentDetail/ShipmentName";
import LogName from "../timber/components/log/LogDetail/LogName";
import CordwoodName from "../timber/components/cordwood/CordwoodDetail/CordwoodName";
import TreeMarkingName from "../timber/components/treeMarking/TreeMarkingDetail/TreeMarkingName";
import LogHistoryName from "../timber/components/logHistory/LogHistoryDetail/LogHistoryName";
import CordwoodHistoryName from "../timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryName";
import ShipmentHistoryName from "../timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryName";


import { t } from "@lingui/core/macro";

export function addressName(id) {
    return <AddressName id={id} />
}
export function userAddressName(id) {
    return <UserAddressName id={id} />
}

export function membersGroupName(id) {
    return <MembersGroupName id={id} />
}
export function userName(id) {
    return <UserName id={id} />
}
export function userSessionName(id) {
    return <UserSessionName id={id} />
}
export function roleName(id) {
    return <RoleName id={id} />
}
export function rolePermissionName(id) {
    return <RolePermissionName id={id} />
}
export function membersGroupUserName(id) {
    return <MembersGroupUserName id={id} />
}
export function scopeGroupName(id) {
    return <ScopeGroupName id={id} />
}
export function roleAssignmentName(id) {
    return <RoleAssignmentName id={id} />
}

export function locationName(id) {
    return <LocationName id={id} />
}

export function timberClassName(id) {
    return <TimberClassName id={id} />
}
export function thicknessClassName(id) {
    return <ThicknessClassName id={id} />
}
export function timberTypeName(id) {
    return <TimberTypeName id={id} />
}
export function pricingProfileName(id) {
    return <PricingProfileName id={id} />
}
export function priceName(id) {
    return <PriceName id={id} />
}
export function buyerName(id) {
    return <BuyerName id={id} />
}
export function buyerUserName(id) {
    return <BuyerUserName id={id} />
}
export function roadCarrierName(id) {
    return <RoadCarrierName id={id} />
}
export function contractorName(id) {
    return <ContractorName id={id} />
}
export function contractorUserName(id) {
    return <ContractorUserName id={id} />
}
export function forestOwnerName(id) {
    return <ForestOwnerName id={id} />
}
export function providerName(id) {
    return <ProviderName id={id} />
}
export function providerUserName(id) {
    return <ProviderUserName id={id} />
}
export function accountingUserName(id) {
    return <AccountingUserName id={id} />
}
export function cuttingName(id) {
    return <CuttingName id={id} />
}
export function timberStorageName(id) {
    return <TimberStorageName id={id} />
}
export function shipmentName(id) {
    return <ShipmentName id={id} />
}
export function logName(id) {
    return <LogName id={id} />
}
export function cordwoodName(id) {
    return <CordwoodName id={id} />
}
export function treeMarkingName(id) {
    return <TreeMarkingName id={id} />
}
export function logHistoryName(id) {
    return <LogHistoryName id={id} />
}
export function cordwoodHistoryName(id) {
    return <CordwoodHistoryName id={id} />
}
export function shipmentHistoryName(id) {
    return <ShipmentHistoryName id={id} />
}



const nameMappers = {
    'addresses': addressName,
    'user-addresses': userAddressName,
    
    'members-groups': membersGroupName,
    'users': userName,
    'user-sessions': userSessionName,
    'roles': roleName,
    'role-permissions': rolePermissionName,
    'members-group-users': membersGroupUserName,
    'scope-groups': scopeGroupName,
    'role-assignments': roleAssignmentName,
    
    'locations': locationName,
    
    'timber-classes': timberClassName,
    'thickness-classes': thicknessClassName,
    'timber-types': timberTypeName,
    'pricing-profiles': pricingProfileName,
    'prices': priceName,
    'buyers': buyerName,
    'buyer-users': buyerUserName,
    'road-carriers': roadCarrierName,
    'contractors': contractorName,
    'contractor-users': contractorUserName,
    'forest-owners': forestOwnerName,
    'providers': providerName,
    'provider-users': providerUserName,
    'accounting-users': accountingUserName,
    'cuttings': cuttingName,
    'timber-storages': timberStorageName,
    'shipments': shipmentName,
    'logs': logName,
    'cordwoods': cordwoodName,
    'tree-markings': treeMarkingName,
    'log-histories': logHistoryName,
    'cordwood-histories': cordwoodHistoryName,
    'shipment-histories': shipmentHistoryName,
    
    
};

const labelMappers = {
    'dashboard': () => t`Dashboard`,
    'addresses': () => t`Addresses`,
    'user-addresses': () => t`User Addresses`,
    
    'members-groups': () => t`Members Groups`,
    'users': () => t`Users`,
    'user-sessions': () => t`User Sessions`,
    'roles': () => t`Roles`,
    'role-permissions': () => t`Role Permissions`,
    'members-group-users': () => t`Members Group Users`,
    'scope-groups': () => t`Scope Groups`,
    'role-assignments': () => t`Role Assignments`,
    
    'locations': () => t`Locations`,
    
    'timber-classes': () => t`Timber Classes`,
    'thickness-classes': () => t`Thickness Classes`,
    'timber-types': () => t`Timber Types`,
    'pricing-profiles': () => t`Pricing Profiles`,
    'prices': () => t`Prices`,
    'buyers': () => t`Buyers`,
    'buyer-users': () => t`Buyer Users`,
    'road-carriers': () => t`Road Carriers`,
    'contractors': () => t`Contractors`,
    'contractor-users': () => t`Contractor Users`,
    'forest-owners': () => t`Forest Owners`,
    'providers': () => t`Providers`,
    'provider-users': () => t`Provider Users`,
    'accounting-users': () => t`Accounting Users`,
    'cuttings': () => t`Cuttings`,
    'timber-storages': () => t`Timber Storages`,
    'shipments': () => t`Shipments`,
    'logs': () => t`Logs`,
    'cordwoods': () => t`Cordwoods`,
    'tree-markings': () => t`Tree Markings`,
    'log-histories': () => t`Log Histories`,
    'cordwood-histories': () => t`Cordwood Histories`,
    'shipment-histories': () => t`Shipment Histories`,
    
    
};

export function mapPathToName(path: string, id: number) {
    const nameFn = nameMappers[path];
    return nameFn && id != 'add' && nameFn(id);
}

export function mapPathToLabel(path: string): string | undefined {
    const m = labelMappers[path]
    return m && m();
}
